import React from 'react'
import { connect } from 'react-redux'

import {
  findAndSelectClosestTideStation,
} from '../../actions/userLocationActions'
import {
  clearSelectedTideStation,
  clearLocationSearch,
} from '../../actions/uiActions'
import { userLocationSelector } from '../../reducers/userLocationReducer'
import { tideStationSelector } from '../../reducers/uiReducer'

import iconLocationOn  from '../../assets/images/icon-location-on.svg'
import iconLocationOff from '../../assets/images/icon-location-off.svg'





// =============
// = Container =
// =============

export default connect(
  state => {
    const userLocation = userLocationSelector(state)
    const selectedTideStation = tideStationSelector(state)

    const isActive = (
      userLocation.station !=  null &&
      userLocation.station === selectedTideStation
    )

    const isFetching = userLocation.isFetching

    return {
      isActive,
      isFetching
    }
  },
  dispatch => {
    return {
      onClick: (e) => {
        dispatch(clearSelectedTideStation())
        dispatch(clearLocationSearch())
        dispatch(findAndSelectClosestTideStation())
      }
    }
  }
)(renderComponent)







// ===============
// = View Render =
// ===============

function renderComponent({styles, onClick, isActive, isFetching}) {

  // Choose icon
  const icon = (isActive) ? iconLocationOn : iconLocationOff

  // Add .isFetching class if appropriate
  let className = styles.FindMyLocationControl
  if (isFetching)
    className += ' ' + styles.isFetching

  return (
    <div
      className={className}
      onClick={onClick}
      ripple=''
    >
      <img className={styles.locationArrow} src={icon} />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/LocationSearch/FindMyLocationControl.js